module.exports = __webpack_public_path__ + "imgs/inventory.91e413a08d1ddd1e846e48fbbf1dde75.svg";